import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DownloadFileDirective} from './download-file.directive';
import {DragNDropFileDirective} from './drag-n-drop-file.directive';
import {ViewAnchorDirective} from './view-anchor.directive';


@NgModule({
  declarations: [DownloadFileDirective, DragNDropFileDirective, ViewAnchorDirective],
  exports: [DownloadFileDirective, DragNDropFileDirective, ViewAnchorDirective],
  imports: [
    CommonModule,
  ],
})
export class DirectivesModule {
}
